if (!customElements.get('search-product-count')) {
  class SearchProductCount extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.updateCount = this.updateCount.bind(this);
    }

    connectedCallback() {
      document.addEventListener('eurus:collection:reloaded', this.updateCount);

      if (!this.hasAttribute('data-product-only')) {
        this.updateCount();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('eurus:collection:reloaded', this.updateCount);
      this.abortController?.abort();
    }

    async updateCount() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      const url = new URL(window.location.href);
      url.searchParams.set('type', 'product');
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.delete('page');
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url.toString(), {
          signal: this.abortController.signal
        });

        if (!response.ok) return;

        const html = await response.text();
        const source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-search-product-count]');
        const target = this.querySelector('[data-search-product-count]');

        if (source && target) {
          target.textContent = source.textContent;
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Unable to update the search product count.', error);
        }
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('search-product-count', SearchProductCount);
}
